import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { webSecurityStatusSelector } from '../selectors/dashboardSelector';
import { getWebSecurityStatusRequest } from '../actions/dashboardActions';
import WebSecurityStatus from '../components/WebSecurityStatus/WebSecurityStatus';

const mapStateToProps = createStructuredSelector({ webSecurityStatus: webSecurityStatusSelector });
const mapDispatchToProps = { getWebSecurityStatusRequest };

export default connect(mapStateToProps, mapDispatchToProps)(WebSecurityStatus);
